import React from 'react';
import { X } from 'lucide-react';

const VideoModal = ({ video, onClose }) => {
  if (!video?.videoUrl) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col">
      <div className="flex items-center justify-between gap-4 p-4 text-white bg-black/80">
        <h2 className="text-sm font-medium line-clamp-1">{video.title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="rounded-full p-2 bg-white/10"
          aria-label="关闭视频"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center">
        <video
          src={video.videoUrl}
          poster={video.cover || undefined}
          className="w-full max-h-full object-contain"
          controls
          autoPlay
          playsInline
        />
      </div>
    </div>
  );
};

export default VideoModal;
